import { DayOfWeekEnum } from 'app/models';

export class DayOfWeekModel {
    public static DayOfWeekList: Array<any> = [
        { name: 'Mon', value: DayOfWeekEnum.Monday },
        { name: 'Tue', value: DayOfWeekEnum.Tuesday },
        { name: 'Wed', value: DayOfWeekEnum.Wednesday },
        { name: 'Thu', value: DayOfWeekEnum.Thursday },
        { name: 'Fri', value: DayOfWeekEnum.Friday },
        { name: 'Sat', value: DayOfWeekEnum.Saturday },
        { name: 'Sun', value: DayOfWeekEnum.Sunday }
    ];
}
